import { render, staticRenderFns } from "./topup.vue?vue&type=template&id=f2afab24&scoped=true"
import script from "./topup.vue?vue&type=script&lang=js"
export * from "./topup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2afab24",
  null
  
)

export default component.exports